(() => {
  'use strict';
  const cfg = window.HRTheme || { routes: { cart: '/cart', cartAdd: '/cart/add', root: '/' }, currency: 'USD' };
  let strings = {};
  try { strings = JSON.parse(document.getElementById('HRLookStrings')?.textContent || '{}'); } catch (_) {}
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cfg.currency || 'USD' }).format((Number(cents) || 0) / 100);
  const initGallery = root => {
    if (root.dataset.hartenInit) return;
    root.dataset.hartenInit = 'true';
    const input = root.querySelector('[data-outfit-search]');
    const buttons = [...root.querySelectorAll('[data-outfit-filter]')];
    const cards = [...root.querySelectorAll('[data-outfit-card]')];
    const empty = root.querySelector('[data-outfit-empty]');
    let category = 'All';
    const update = () => {
      const term = (input?.value || '').toLocaleLowerCase().trim();
      let count = 0;
      for (const card of cards) {
        const show = (category === 'All' || card.dataset.category === category) && (!term || (card.dataset.searchable || '').toLocaleLowerCase().includes(term));
        card.hidden = !show;
        if (show) count++;
      }
      if (empty) empty.hidden = count > 0;
    };
    input?.addEventListener('input', update);
    for (const button of buttons) button.addEventListener('click', () => {
      category = button.dataset.outfitFilter;
      for (const b of buttons) {
        b.classList.toggle('is-active', b === button);
        b.setAttribute('aria-pressed', String(b === button));
      }
      update();
    });
    update();
  };
  const initOutfit = root => {
    if (root.dataset.hartenInit) return;
    root.dataset.hartenInit = 'true';
    const states = [...root.querySelectorAll('[data-outfit-piece]')].map(element => {
      let variants = [];
      try { variants = JSON.parse(element.querySelector('[data-piece-variants]')?.textContent || '[]'); } catch (_) {}
      const selectors = [...element.querySelectorAll('[data-piece-option]')];
      const allowed = variants.filter(v => selectors.every((s, index) => !['color','colour'].includes(s.dataset.optionName) || [...s.options].some(o => o.value === String(v.options[index]))));
      const check = element.querySelector('[data-piece-check]');
      if (check && !allowed.some(v => v.available)) {
        check.checked = false;
        check.disabled = true;
      }
      return { element, variants: allowed, selectors, check, photo: element.querySelector('.hr-outfit-piece__image img'), price: element.querySelector('[data-piece-price]'), status: element.querySelector('[data-piece-availability]') };
    });
    const addSelected = root.querySelector('[data-add-selected]');
    const addComplete = root.querySelector('[data-add-complete]');
    const status = root.querySelector('[data-outfit-status]');
    const selectedTotal = root.querySelector('[data-selected-total]');
    const completeTotal = root.querySelector('[data-complete-total]');
    const selectedSubtotal = root.querySelector('[data-selected-subtotal]');
    const selectedSaving = root.querySelector('[data-selected-saving]');
    const offerRows = [...root.querySelectorAll('[data-selection-subtotal-row], [data-selection-saving-row]')];
    const offerRate = Number(root.dataset.offerPercentage || 0) / 100;
    const offerMinimum = Number(root.dataset.offerMinimum || Infinity);
    const offerEnabled = root.dataset.offerEnabled === 'true' && offerRate > 0 && offerRate < 1;
    let busy = false;
    const match = piece => piece.selectors.length ? piece.variants.find(v => v.options.length === piece.selectors.length && v.options.every((value, index) => String(value) === piece.selectors[index].value)) || null : piece.variants.length === 1 ? piece.variants[0] : null;
    const possible = piece => piece.variants.filter(v => piece.selectors.every((select, index) => !select.value || String(v.options[index]) === select.value));
    const update = () => {
      let selectedSum = 0, completeSum = 0, count = 0, selectedOfferSaving = 0;
      let selectedValid = true, completeValid = states.length === Number(root.dataset.expectedPieces) && states.length > 0, selectedPriceKnown = true, completePriceKnown = true;
      for (const piece of states) {
        piece.element.classList.toggle('is-excluded', !piece.check?.checked);
        const selected = match(piece);
        const available = possible(piece).filter(v => v.available);
        const price = selected ? selected.price : available.length ? Math.min(...available.map(v => v.price)) : null;
        const valid = Boolean(selected?.available);
        const hasSelection = piece.selectors.every(select => select.value);
        if (piece.price) piece.price.textContent = price === null ? '—' : money(price);
        if (piece.status) piece.status.textContent = !piece.variants.some(v => v.available) || hasSelection && !valid ? strings.unavailable : valid ? '' : strings.sizePrompt;
        const color = piece.selectors.find(s => ['color','colour'].includes(s.dataset.optionName))?.value;
        const src = piece.element.dataset.editorialColor === color && piece.element.dataset.editorialSrc ? piece.element.dataset.editorialSrc : selected?.featured_image?.src || available[0]?.featured_image?.src;
        if (piece.photo && src && piece.photo.dataset.variantImage !== src) {
          piece.photo.src = src;
          piece.photo.removeAttribute('srcset');
          piece.photo.dataset.variantImage = src;
          const detailPhoto = piece.element.querySelector('[data-catalog-detail]');
          if (detailPhoto) detailPhoto.src = src;
        }
        for (let index = 0; index < piece.selectors.length; index++) {
          for (const option of piece.selectors[index].options) {
            if (!option.value) continue;
            option.disabled = !piece.variants.some(v => v.available && String(v.options[index]) === option.value && piece.selectors.every((other, j) => j === index || !other.value || String(v.options[j]) === other.value));
          }
        }
        if (!valid) completeValid = false;
        if (price === null) completePriceKnown = false; else completeSum += price;
        if (piece.check?.checked) {
          count++;
          if (!valid) selectedValid = false;
          if (price === null) selectedPriceKnown = false; else {
            selectedSum += price;
            selectedOfferSaving += Math.round(price * offerRate);
          }
        }
      }
      const offerApplies = offerEnabled && selectedPriceKnown && count > 0 && selectedSum >= offerMinimum;
      const savings = offerApplies ? selectedOfferSaving : 0;
      if (selectedSubtotal) selectedSubtotal.textContent = selectedPriceKnown ? money(selectedSum) : '—';
      if (selectedSaving) selectedSaving.textContent = '−' + money(savings);
      offerRows.forEach(row => { row.hidden = !offerApplies; });
      if (selectedTotal) selectedTotal.textContent = selectedPriceKnown ? money(selectedSum - savings) : '—';
      if (completeTotal) completeTotal.textContent = completePriceKnown ? money(completeSum) : '—';
      if (addSelected) addSelected.disabled = busy || !count || !selectedValid;
      if (addComplete) addComplete.disabled = busy || !completeValid;
      if (status && !busy) status.textContent = !count ? strings.noSelection : selectedValid ? '' : strings.selectOptions;
    };
    const submit = async (pieces, button) => {
      if (busy || !pieces.length) return;
      const variants = pieces.map(match);
      if (variants.some(v => !v?.available)) { update(); return; }
      busy = true;
      const label = button.textContent;
      button.textContent = strings.adding;
      if (status) status.textContent = '';
      root.setAttribute('aria-busy', 'true');
      update();
      try {
        const response = await fetch((cfg.routes.cartAdd || '/cart/add').replace(/\/$/, '') + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: variants.map(v => ({ id: v.id, quantity: 1, properties: { Outfit: root.dataset.lookName, _hr_look: root.dataset.lookSlug } })) })
        });
        let result = {};
        try { result = await response.json(); } catch (_) {}
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : strings.addError);
        window.location.assign(cfg.routes.cart || '/cart');
      } catch (error) {
        busy = false;
        root.removeAttribute('aria-busy');
        button.textContent = label;
        update();
        if (status) status.textContent = error.message || strings.addError;
      }
    };
    states.forEach(piece => {
      piece.check?.addEventListener('change', update);
      piece.selectors.forEach(select => select.addEventListener('change', update));
    });
    addSelected?.addEventListener('click', () => submit(states.filter(p => p.check?.checked), addSelected));
    addComplete?.addEventListener('click', () => submit(states, addComplete));
    update();
  };
  const init = scope => {
    if (scope.matches?.('[data-outfit-gallery]')) initGallery(scope);
    if (scope.matches?.('[data-outfit-detail]')) initOutfit(scope);
    scope.querySelectorAll?.('[data-outfit-gallery]').forEach(initGallery);
    scope.querySelectorAll?.('[data-outfit-detail]').forEach(initOutfit);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  const routeLegacyLook = () => {
    if (!window.location.hash.startsWith('#look-')) return;
    const card = [...document.querySelectorAll('[data-outfit-slug]')].find(c => c.dataset.outfitSlug === window.location.hash.slice(6));
    if (card) window.location.replace(card.href);
  };
  window.addEventListener('hashchange', routeLegacyLook);
  routeLegacyLook();
})();
